import { render, staticRenderFns } from "./MasterCharterCompany.vue?vue&type=template&id=5b85a072&scoped=true&"
import script from "./MasterCharterCompany.vue?vue&type=script&lang=js&"
export * from "./MasterCharterCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85a072",
  null
  
)

export default component.exports